var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "p-3" }, [
    _c("h3", [_vm._v("Kesehatan Gigi dan Mulut")]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "row mt-3" }, [
      _c("h4", { staticClass: "mb-3" }, [_vm._v("Pencarian Data")]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-3" }, [
        _c("div", { staticClass: "mb-3 row" }, [
          _c(
            "label",
            {
              staticClass: "col-sm-4 col-form-label text-end",
              attrs: { for: "year" },
            },
            [_vm._v("Tahun")]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-8" },
            [
              _c("v-select", {
                attrs: {
                  clearable: false,
                  multiple: false,
                  options: _vm.data_year,
                  label: "name",
                  name: "year",
                  id: "year",
                  placeholder: "Pilih Tahun",
                  single: true,
                },
                on: {
                  input: function ($event) {
                    return _vm.setYear($event)
                  },
                },
                model: {
                  value: _vm.year,
                  callback: function ($$v) {
                    _vm.year = $$v
                  },
                  expression: "year",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-sm-2" }, [
        _c("div", { staticClass: "mb-3" }, [
          _c("div", { staticClass: "col-sm-8 text-end" }, [
            _c(
              "button",
              { staticClass: "btn btn-primary", on: { click: _vm.getPel } },
              [
                _c("i", { staticClass: "fa fa-search" }),
                _vm._v("\n                        Cari"),
              ]
            ),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("hr"),
    _vm._v(" "),
    _c("div", { staticClass: "card mb-3" }, [
      _c("div", { staticClass: "card-header text-white bg-primary" }, [
        _vm._v("Data Kesehatan Gigi dan Mulut"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { attrs: { id: "table" } }, [
          _c(
            "table",
            { staticClass: "table table-bordered" },
            [
              _vm._m(0),
              _vm._v(" "),
              _vm._l(_vm.data_pel, function (item, index) {
                return _c("tbody", { key: index }, [
                  _c("tr", [
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.NomorKodeRS) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.NamaRS) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(_vm.KotaKab) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.DIAGNOSA) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { staticStyle: { "text-align": "center" } }, [
                      _vm._v(
                        "\n                                " +
                          _vm._s(item.jumlah) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ])
              }),
            ],
            2
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Kode RS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Nama RS")]),
        _vm._v(" "),
        _c("th", [_vm._v("Kab/Kota")]),
        _vm._v(" "),
        _c("th", [_vm._v("Diagnosa")]),
        _vm._v(" "),
        _c("th", [_vm._v("Jumlah")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }